import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from "@tanstack/react-query";

import { managedLiveReportLinksQueryKey } from "./useManagedLiveReportLinks";
import { revokeManagedLiveReportLink } from "../../client/manager/live-report";
import { useTixologiTokenRefresher } from "./useTixologiTokenRefresher";

export function useRevokeManagedLiveReportLink(
  partnerId: string | undefined,
  isComedian = false
): UseMutationResult<void, Error, number> {
  const queryClient = useQueryClient();
  const { token, refresh } = useTixologiTokenRefresher(partnerId, isComedian);

  return useMutation({
    mutationFn: async (id: number) => {
      const initial = token ?? (await refresh());
      if (!initial) throw new Error("Tixologi token not available");
      return revokeManagedLiveReportLink(initial, id, refresh);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: managedLiveReportLinksQueryKey(partnerId),
      });
    },
  });
}
